import { Shield, Award, MapPin, Users, Medal, BadgeCheck } from "lucide-react";

const badges = [
  { icon: Medal, label: "Veteran-Owned", highlight: true },
  { icon: Users, label: "Family-Operated" },
  { icon: BadgeCheck, label: "ROC 362827" },
  { icon: Shield, label: "Licensed & Bonded" },
  { icon: Award, label: "Fully Insured" },
  { icon: Shield, label: "BBB Accredited" },
  { icon: MapPin, label: "Local West Valley" },
];

const TrustBadges = () => {
  return (
    <div className="bg-muted/50 border-y border-border py-6">
      <div className="container">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-6">
          {badges.map((badge, index) => (
            <div
              key={index}
              className={`flex items-center justify-center gap-2 text-center rounded-full px-3 py-1.5 ${
                badge.highlight
                  ? "gradient-copper"
                  : "md:bg-transparent md:px-0 md:py-0 bg-card border border-border md:border-0"
              } ${index === 5 ? "hidden md:flex" : ""}`}
            >
              <badge.icon
                className={`h-4 w-4 md:h-5 md:w-5 flex-shrink-0 ${
                  badge.highlight ? "text-primary-foreground" : "text-primary"
                }`}
              />
              <span
                className={`text-xs md:text-sm font-medium truncate ${
                  badge.highlight
                    ? "text-primary-foreground font-bold"
                    : "text-foreground/90"
                }`}
              >
                {badge.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustBadges;